applicationOverview.classy.controller({
    name: "ApplicationOverviewController",
    inject: ["$scope", "$timeout", 
        "SchoolSubcategoriesModelService", "ApplicationService", "AlertService", "SliderService", 
        "ApplicationSideBarService", "AppModelService", "BinFactory", "DetermineAwardService", 
        "DateService", "CheckListService", "TabsService", "SliderFactory",
        "authServiceFactory", "SchoolModelService"],
    init: function()
    {
        this.$.bin = this.$.binChoice();  
        this.$.ApplicationService = this.ApplicationService;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.DateService = this.DateService;
        this.$.ApplicationSideBarService = this.ApplicationSideBarService;
        this.$.CheckListService = this.CheckListService;
        this.$.SliderService = this.SliderService;
        this.$.secondSliderService = this.SliderService;
        this.$.categories = this.SchoolSubcategoriesModelService.get();
        this.$.categoriesOpen = false;
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.tabs = [
            {title: 'Recommended Award', url: 'recommendedAward'},
            {title: 'Calculated Award', url: 'calculatedAward'}
        ]
        this.$.activeTab = 'recommendedAward';
        this.$timeout(function() {
            var $window = $(window).on('resize', function(){
                var height = $(this).height() - 165;
                $('.family-overview-slider-container').css("height", height + 'px');
            }).trigger('resize');
        }, 100);
        this.$.confidential = this.authServiceFactory.getAuth().permissions.confidential;
    },
    setActiveTab: function(url) {
        this.$.activeTab = url;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
    },
    fixedElChromeFix: function() {
        //hotfix for crazy scrolling issue in fixed elements in chrome
        $("#combinedChecklist").hide().delay(400).queue(function() {
            $(this).show();
        });
    },
    binChoice: function()
    {
        if (typeof this.ApplicationService.getAwardData() !== "undefined")
        {
            if (this.ApplicationService.getAwardData().app[0].Status_New == 1)
                return "Status_New";
            else if (this.ApplicationService.getAwardData().app[0].Status_Consider == 1)
                return "Status_Consider";
            else if (this.ApplicationService.getAwardData().app[0].Status_Award == 1)
                return "Status_Award";
            else if (this.ApplicationService.getAwardData().app[0].Status_Viewed == 1)
                return "Status_Viewed";
            else if (this.ApplicationService.getAwardData().app[0].Status_Reject == 1)
                return "Status_Reject";
        }
    },
    finishApp: function()
    {
        this.ApplicationSideBarService.setBin("Status_Viewed");
    },
    restartApp: function()
    {
        this.ApplicationSideBarService.setBin("Status_Unfinished");
    },
    hasAlertsClass: function()
    {
        for (var key in this.AlertService.getAlerts()) {
            var ballClass = this.$.getBallClass(key);
            if (ballClass == "text-warning" || ballClass == "text-danager")
                return "text-warning";
        }
        return "text-success";
    },
    getBallClass: function(alertName)
    {
        var alert = this.AlertService.getAlerts()[alertName];
        if (alert.fired == true && alert.complete == 1)
            return "text-" + alert.stateType;
        else
        {
            if (alert.state == "disabled" || alert.state == "void")
                return "text-success";
            return "text-" + alert.state;
        }
    },
    awardData: function(index, div)
    {
        var parent = this;
        this.ApplicationService.setFamilyNo(index)
        //this.MainContentService.setActiveDiv("tabs");
        parent.TabsService.setActiveTab("awardData");
    },
    setCategoriesOpenContainer: function(value) {
        this.$.categoriesOpen = value;
    },
    getField: function(item, field)
    {
        if (typeof item['x' + field] == 'undefined' || item['x' + field] === null || item['x' + field] == '' || item[field] == item['x' + field])
            return item[field] 
        else
            return item['x' + field];
    },
    setPartial: function(partial, header, size)
    {
        this.SliderService.pushSlider(new this.SliderFactory(partial, header, size));
    }
});

